import _ from '../util/underscore-wrapper';
import BaseCollection from './BaseCollection';
import BaseModel from './BaseModel';
import SchemaProperty from './SchemaProperty';

const parseProperties = function (resp) {
  const schemaMeta = _.pick(resp, 'id', 'name', 'displayName');

  const properties = _.map(resp.schema.properties, function (property, name) {
    return _.extend({ name }, property);
  });

  _.each(properties, function (property) {
    property['__schemaMeta__'] = schemaMeta;

    if (property.__metadata) {
      property['__metadata__'] = property.__metadata;
      delete property.__metadata;
    }
  });
  return properties;
};

const BaseSchemaSchema = BaseModel.extend({
  defaults: {
    id: undefined,
    displayName: undefined,
    name: undefined
  },

  constructor: function () {
    this.properties = new SchemaProperty.Collection();
    BaseModel.apply(this, arguments);
  },

  getProperties: function () {
    return this.properties;
  },

  clone: function () {
    const model = BaseModel.prototype.clone.apply(this, arguments);

    model.getProperties().set(this.getProperties().toJSON({ verbose: true }));
    return model;
  },

  parse: function (resp) {
    const properties = parseProperties(resp);

    this.properties.set(properties, { parse: true });
    return _.omit(resp, 'schema');
  },

  trimProperty: function (property) {
    return _.omit(property, 'name');
  },

  toJSON: function () {
    const json = BaseModel.prototype.toJSON.apply(this, arguments);

    json.schema = { properties: {} };
    this.getProperties().each(function (model) {
      const property = model.toJSON();

      json.schema.properties[property.name] = this.trimProperty(property);
    }, this);
    return json;
  },

  save: function () {
    this.getProperties().each(function (model) {
      model.cleanup();
    });
    return BaseModel.prototype.save.apply(this, arguments);
  }
});
const BaseSchemaSchemas = BaseCollection.extend({
  model: BaseSchemaSchema
});
export default {
  parseProperties: parseProperties,
  Model: BaseSchemaSchema,
  Collection: BaseSchemaSchemas
};



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/models/BaseSchema.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/models/BaseSchema.js